export default __webpack_public_path__ + "static/media/i-learn-to-count-puzzle-4.500db4bc.jpg";